import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "privacy-scope",
    title: "Scope of this notice",
    body: [
      "This notice explains how nartvmora handles information when visitors browse, place an order or contact customer care.",
      "nartvmora operates from 116 Jln Kuras, Singapore 577782. Privacy enquiries can be sent to east@nartvmora.site.",
    ],
  },
  {
    id: "information-collected",
    title: "Information a live store may collect",
    items: [
      "Contact and delivery details, such as name, email and shipping address.",
      "Order information, including products, sizes, quantities, discounts, delivery status and return history.",
      "Account and preference information, where optional customer accounts are offered.",
      "Device and usage information, such as browser type, approximate location, pages viewed and security logs, if production analytics or hosting tools are enabled.",
      "Messages, reviews or other information a customer chooses to send to customer care.",
    ],
  },
  {
    id: "local-storage",
    title: "Cart storage and cookies",
    body: [
      "The cart stores product selections in the visitor's browser using local storage so they remain available after a refresh. Clearing site data in the browser removes this local cart information.",
      "Essential cookies may be used for security, checkout and preferences. Non-essential analytics or advertising technologies require any consent mandated by applicable law.",
    ],
  },
  {
    id: "how-used",
    title: "How information may be used",
    items: [
      "To provide checkout, fulfilment, delivery, returns and customer support.",
      "To secure the service, prevent misuse and investigate suspected fraud.",
      "To maintain the website, understand performance and improve the shopping experience.",
      "To meet record-keeping, tax, regulatory or dispute obligations that apply to the operator.",
    ],
  },
  {
    id: "payment-data",
    title: "Payment information",
    body: [
      "Card details are entered only on the secure page of the payment provider; nartvmora does not ask for or store raw card details on this website.",
      "The payment provider processes payment information under its own privacy notice. We receive only the transaction information needed to manage the order.",
    ],
  },
  {
    id: "sharing",
    title: "Sharing and international processing",
    body: [
      "A live store may share only the information needed by service providers such as hosting platforms, payment processors, warehouses, carriers, support tools and professional advisers. Personal information should not be sold, and providers should be contractually limited to approved purposes.",
      "If information is processed in another country, the operator must assess the transfer and use the safeguards required for the affected customers before enabling that service.",
    ],
  },
  {
    id: "retention-security",
    title: "Retention and security",
    body: [
      "Information should be retained only while it is needed for the stated purpose or a legal obligation, then deleted or anonymised. Different records may require different retention periods.",
      "Reasonable technical and organisational safeguards can reduce risk, but no internet service can promise absolute security. A production incident-response and breach-notification process must be established before launch.",
    ],
  },
  {
    id: "privacy-rights",
    title: "Choices and privacy rights",
    body: [
      "Depending on location, a person may be able to request access, correction, deletion, restriction, objection, portability or withdrawal of consent. Identity may need to be verified before a request is completed, and some records may need to be kept where the law requires it.",
      "Browser settings can be used to clear local storage and manage cookies.",
    ],
    links: [{ to: "/contact", label: "Make a privacy request" }],
  },
  {
    id: "children-updates",
    title: "Children and policy updates",
    body: [
      "The storefront is intended for adults and is not designed to knowingly collect information from children. The live operator must set an appropriate age approach for its markets.",
      "The final notice should show an effective date and be updated whenever data practices or providers materially change. Significant changes should be communicated in a way appropriate to the affected customers.",
    ],
    links: [
      { to: "/terms", label: "Read the terms of use" },
      { to: "/contact", label: "Contact us" },
    ],
  },
];

function Privacy() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Privacy Notice"
      intro="How nartvmora collects, uses and protects customer information."
      updated="Effective September 2026"
      sections={sections}
      action={{ to: "/contact", label: "Ask a privacy question" }}
    />
  );
}

export default Privacy;
